import { LegalFormResponse } from 'generated/api-client';

const PRIORITIZED_LEGAL_FORM_CODES = ['5499', '5710', '1000'];

const frenchCollator = new Intl.Collator('fr', {
  sensitivity: 'base',
});

// Assign a sort bucket before the alphabetical sort:
// 0..2 for prioritized codes, then regular labels, then labels starting with '(Autre)'.
const getSortGroup = ({ code, label }: LegalFormResponse) => {
  const prioritizedIndex = PRIORITIZED_LEGAL_FORM_CODES.indexOf(code);

  if (prioritizedIndex !== -1) {
    return prioritizedIndex;
  }

  return (
    PRIORITIZED_LEGAL_FORM_CODES.length + Number(label.startsWith('(Autre)'))
  );
};

/**
 * Orders legal forms for display.
 *
 * Sorting rules:
 * - legal forms whose code appears in `PRIORITIZED_LEGAL_FORM_CODES` always come first,
 *   as they are the most common ones;
 * - other legal forms are then sorted alphabetically by label;
 * - labels starting with `(Autre)` are always pushed to the end.
 */
export const orderLegalForms = (legalForms: LegalFormResponse[]) =>
  legalForms.sort((left, right) => {
    const groupDifference = getSortGroup(left) - getSortGroup(right);

    if (groupDifference !== 0) {
      return groupDifference;
    }

    return frenchCollator.compare(left.label, right.label);
  });
